import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=d05af86a&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05af86a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05af86a')) {
      api.createRecord('d05af86a', component.options)
    } else {
      api.reload('d05af86a', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=d05af86a&scoped=true&", function () {
      api.rerender('d05af86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GZ57B9oWzZAL/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports